module.exports = __webpack_public_path__ + "static/kanada-e97f49d12b7e3d66d9802d5e54d5b2eb.svg";